import axios from "axios";

export const serviceAxios = axios.create({
    baseURL: import.meta.env.VITE_BASE_URL , //change with env variable
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
})

export const privateAxios = axios.create({
    baseURL: import.meta.env.VITE_BASE_URL,
    withCredentials: true,
    //timeout: 5000,
    headers: { 'Content-Type': 'application/json' },
})
